export default __webpack_public_path__ + "static/media/theWeather-demo.500562e7.gif";